export default __webpack_public_path__ + "static/media/Raveendrudu@2x.54936e20.jpeg";